"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
class Cognito {
    constructor(config) {
        this._poolData = {
            UserPoolId: config.userPoolId,
            ClientId: config.userPoolWebClientId,
        };
        this._userPool = new amazon_cognito_identity_js_1.CognitoUserPool(this._poolData);
        console.log('[cognito.constructor()]');
    }
    GetAuthenticatedUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const userPool = new amazon_cognito_identity_js_1.CognitoUserPool(this._poolData);
            return userPool.getCurrentUser();
        });
    }
    login(userEmail, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    const authenticationData = {
                        Username: userEmail,
                        Password: password,
                    };
                    const authenticationDetails = new amazon_cognito_identity_js_1.AuthenticationDetails(authenticationData);
                    const userData = {
                        Username: userEmail,
                        Pool: this._userPool,
                    };
                    const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
                    cognitoUser.authenticateUser(authenticationDetails, {
                        onSuccess: function (result) {
                            console.log('[cognito.login.success]');
                            return resolve(result);
                        },
                        onFailure: function (err) {
                            console.log('[cognito.login.error]', err);
                            return reject(err);
                        },
                    });
                }
                catch (error) {
                    throw error;
                }
            });
        });
    }
    confirmSignup(userEmail, confirmationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const userData = {
                    Username: userEmail,
                    Pool: this._userPool,
                };
                const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
                cognitoUser.confirmRegistration(confirmationCode, true, function (err, result) {
                    if (err) {
                        console.log('[cognito.confirmSignup.error]', err);
                        reject(err);
                    }
                    else {
                        console.log('[cognito.confirmSignup.success]: ' + JSON.stringify(result));
                        resolve();
                    }
                });
            });
        });
    }
    signup(userEmail, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const attributeList = [];
                const dataEmail = {
                    Name: 'email',
                    Value: userEmail,
                };
                const attributeEmail = new amazon_cognito_identity_js_1.CognitoUserAttribute(dataEmail);
                attributeList.push(attributeEmail);
                this._userPool.signUp(userEmail, password, attributeList, null, function (err, result) {
                    if (err) {
                        console.log('[cognito.signup.error]', JSON.stringify(err));
                        return reject(err);
                    }
                    console.log('[cognito.signup.success]: ' + result.user.getUsername());
                    console.log(result.user);
                    return resolve(result.user);
                });
            });
        });
    }
    forgotPassword(userEmail) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const userData = {
                    Username: userEmail,
                    Pool: this._userPool,
                };
                const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
                cognitoUser.forgotPassword({
                    onSuccess: function (data) {
                        console.log('[cognito.forgotPassword.success]', JSON.stringify(data));
                        resolve();
                    },
                    onFailure: function (err) {
                        console.log('[cognito.forgotPassword.error]', JSON.stringify(err));
                        reject(err);
                    },
                });
            });
        });
    }
    resendConfirmationCode(userEmail) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const userData = {
                    Username: userEmail,
                    Pool: this._userPool,
                };
                const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
                cognitoUser.resendConfirmationCode(function (error, result) {
                    if (error) {
                        console.log('[cognito.resendConfirmationCode.error]', error);
                        return reject(error);
                    }
                    console.log('[cognito.resendConfirmationCode.success]: ' + JSON.stringify(result));
                    // resolve();
                    return resolve(result);
                });
            });
        });
    }
    resetPassword(userEmail, newPassword, verificationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const userData = {
                    Username: userEmail,
                    Pool: this._userPool,
                };
                const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
                cognitoUser.confirmPassword(verificationCode, newPassword, {
                    onSuccess() {
                        console.log('[cognito.confirmForgotPassword.success]');
                        resolve();
                    },
                    onFailure(err) {
                        console.log('[cognito.confirmForgotPassword.error]', JSON.stringify(err));
                        reject(err);
                    },
                });
            });
        });
    }
    changePassword(oldPassword, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const currentUser = yield this.GetAuthenticatedUser();
                if (currentUser) {
                    currentUser['getSession'](function (err, session) {
                        console.log(`[session]`, session);
                        if (err) {
                            reject(err);
                        }
                        else {
                            currentUser['changePassword'](oldPassword, password, function (err, res) {
                                if (err) {
                                    reject(err);
                                }
                                else {
                                    resolve(res);
                                }
                            });
                        }
                    });
                }
                else {
                    reject('User is not authenticated');
                }
            }));
        });
    }
    logout(userEmail) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const userData = {
                    Username: userEmail,
                    Pool: this._userPool,
                };
                const cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
                cognitoUser.signOut();
            }
            catch (error) {
                console.log('[cognito.logout.error]', JSON.stringify(error));
                throw error;
            }
        });
    }
}
exports.default = Cognito;
